export default __webpack_public_path__ + "static/media/Triangles_09.767e7382.png";